import Theme from '@adsk/alloy-react-theme';

export const buttonStyle = {
  height: '25px',
  marginLeft: '11px',
  minWidth: '128px',
  ...Theme.typography.ellipsis,
  ...Theme.typography.labelSmall,
};

export const messageStyle = {
  display: 'flex',
  alignItems: 'center',
  ...Theme.typography.bodyMedium,
  ...Theme.typography.ellipsis,
  [Theme.mediaQuery.medium]: {
    display: 'none',
  },
};
